export function mobile(rule, value, callback){
	var MobileRegex = /^1[0-9]{10}$/;
    if (!MobileRegex.test(value)) {
        callback(new Error('手机号码格式不正确！'))
    } else {
        callback();
    }
}


export function telephone(rule, value, callback)// 正则判断
{
    var isPhone = /^1[0-9]{10}$/;//手机号码
    var isMob= /^0\d{2,3}-?\d{7,8}(-(\d{1,6}))?$/;// 座机格式
    if(isMob.test(value)||isPhone.test(value)){
         callback();
    }else{
         callback(new Error('格式不正确！'))
    }
}

export function password(rule, value, callback){
    if(!value){
        callback();
    }
    var MobileRegex = /^[0-9a-zA-Z]*$/g;
    if (!MobileRegex.test(value)) {
        callback(new Error('只能为数字和字母！'))
    } else {
        if (!/^.*?[\d]+.*$/.test(value) || !/^.*?[A-Za-z].*$/.test(value)){
            callback(new Error('必须包含数字和字母！'))
        }else{
           callback();
        }
    }
}
export function isNumber(rule, value, callback){
    var MobileRegex = /^[0-9]+$/g;
    if (!MobileRegex.test(value)) {
        callback(new Error('只能为数字！'))
    } else {
        callback();
    }
}

export function price(rule, value, callback){
    var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    if (!reg.test(value)) {
        callback(new Error('价格格式不对！'))
    } else {
        callback();
    }
}

export function url(rule, value, callback){

    // var strRegex ='(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$';
    // var re = new RegExp(strRegex);
    let res = !value.match(/(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g);
    if(res) {
        callback(new Error('链接格式不对！'))
    }else{
        callback();
    }
}
export function watermarkContentVaild(rule, value, callback){
    if(!value){
        callback();
        return
    }
    let length=value.replace(/[^\x00-\xff]/g,'01').length
    if(length>40){
        callback(new Error("不超过20个中文或40个字符"))
    }else{
        callback();
    }
}



// WEBPACK FOOTER //
// ./src/utils/validator.js